import API, { defaultHeaders } from '@/api';
import Storage from '@/service/Storage';

const user = () => {
  const headers = Object.assign({}, defaultHeaders);
  headers.Authorization = `Bearer ${Storage.getItem('token')}`;
  return fetch(`${API}/user/me`, { headers });
};

export default user;
